/**
 * Підписи полів перевізника — одне джерело для ресурсу, картки, історії змін і
 * помилок 422 (`SPEC-010` §5.1, §9.4). Тексти — дослівно з легасі
 * (`CarrierResource.jsx`, `frontend/src/Ship/Locales/uk/translation.json`).
 *
 * ⚠️ Бек пише ті самі підписи в `payload` події `carrier_updated`
 * (`CarrierHistoryService`, `SPEC-010` §12). Розійдуться — стрічка історії
 * назве поле не так, як картка поруч.
 */
export const CARRIER_FIELD_LABELS = {
    id: 'Ід',
    title: 'Назва',
    fullName: 'Повна назва',
    status: 'Статус',
    responsibles: 'Відповідальний',
    emails: 'Пошта',
    phones: 'Телефони',
    lardi: 'Lardi (посилання)',
    comment: 'Коментар',
    tags: 'Теги',
    carTypes: 'Типи авто',
    carParkSize: 'Кількість авто в парку',
    countries: 'Країни перевезення',
    formTaxation: 'Форма оподаткування',
    address: 'Адреса',
    iban: 'Рахунок IBAN',
    bank: 'Банк рахунку',
    mfo: 'МФО банку рахунку',
    edrpou: 'Код ЄДРПОУ',
    numberVAT: 'Номер витягу платника ПДВ',
    ipn: 'ІПН',
    manager: 'ПІБ директора',
    forwarder: 'Експедитор перевізника',
    contactPerson: 'Контактна особа, з ким ведуться перемовини',
    carOwnershipType: 'Тип власності авто',
    isCoincidenceCarRegistration: 'Збіг реєстрації а/м за техпаспортом з реєстрацією перевізника',
    isInspectionEdrpou: 'Перевірка по ЄДРПОУ (адреса, вид діяльності, Директор, Статус та ін)',
    isCarInspectionOpendatabot: 'Перевірка автомобіля через OpenDataBot',
    lardiChanges: 'Останні зміни контактів Lardi',
    numberPositiveReviews: 'К-сть позитивних відгуків',
    numberNegativeReviews: 'К-сть негативних відгуків',
    mentionInGoogle: 'Згадка перевізника в Google',
    approximateCostCargo: 'Орієнтовна вартість вантажу',
    cmrInsurance: 'Наявність CMR страхування перевізника, сума покриття',
    recommendation1: 'Рекомендації контактної особи та перевізника (1) від',
    recommendation2: 'Рекомендації контактної особи та перевізника (2) від',
    recommendation3: 'Рекомендації контактної особи та перевізника (3) від',
    filesRegistrationDocuments: 'Реєстраційний документ',
    filesTechnicalPassports: 'Технічний паспорт',
    filesCmrInsurance: 'CMR страхування',
    filesOther: 'Інше',
    verifiedBy: 'Ким верифіковано',
    verifiedAt: 'Дата та час верифікації',
    commentVerification: 'Коментар до верифікації',
    createdAt: 'Дата створення',
    createdBy: 'Хто створив',
    updatedAt: 'Дата зміни',
    updatedBy: 'Хто змінив',
} as const

export type CarrierFieldName = keyof typeof CARRIER_FIELD_LABELS

/**
 * Пара «сума + валюта» (`SPEC-010` §4 п. 9, `SPEC-008` §4.8): у картці — одне
 * поле `CostCurrencyField`, у формі створення валюта за замовчуванням — EUR
 * (R-02). У перевізника вона одна.
 */
export const CARRIER_COST_FIELDS = [{ amount: 'approximateCostCargo', currency: 'approximateCostCargoCurrency' }] as const
